<template>
  <div>
  <!-- Slider -->
  <section class='home__banner'>
    <carousel :per-page="1" :autoplay="true" :autoplayTimeout="5000" :loop="true" :paginationEnabled="false" :navigationEnabled="true">
      <slide>
        <img class='home__slide-image' src='@/assets/images/home/banner1.png'>
      </slide>
      <slide>
        <img class='home__slide-image' src='@/assets/images/home/banner2.png'>
      </slide>
      <slide>
        <img class='home__slide-image' src='@/assets/images/home/banner3.png'>
      </slide>
    </carousel>
  </section>
  <!-- / Slider -->
  <section>
    <SectionHeader title="Insight about the company"></SectionHeader>
    <div class='common__section-body home__company-insight'>
      <p>
        We wish to introduce ourselves as one of leading Class 1 Electrical Contractors undertaking transformer oil filtration at site.
      </p>
      <p>
        The Company was Estd. in the year 1978 by Technocrat Mr A.K. Nagaraj who was formerly working in Crompton Greaves Limited, Transformer Division at Mumbai and Chennai.
      </p>
      <p>
        We are authorized from C.E.I.G and are Class 1 Contractors.
      </p>
      <p>
        The company has vast experienced personnel, who have been serving the firm for over 10 to 15 years in this line of activity,
      </p>
      <p>
        We follow highest degree of professionalism and documentation with ethical practices in industry.
      </p>
      <p>
        We have vast number of satisfied clientele in various spheres.
      </p>
    </div>
  </section>
  <hr class='common__section-divider' />
  <section>
    <SectionHeader title="Gallery"></SectionHeader>
    <div class='common__section-body'>
      <div class='home__gallery-container common__hide-scroller'>
        <div v-bind:key="item.src" class='home__gallery-div' v-for="item in gallery
        ">
          <img :src="item.src">
        </div>
      </div>
      <p class='home__view-more'>
        <router-link to='/gallery'>View More</router-link>
      </p>
    </div>
  </section>
  <hr class='common__section-divider' />
  <section>
    <SectionHeader title="Clientele"></SectionHeader>
    <div class='common__section-body home__clientele-body'>
      <div class='home__clients-container common__hide-scroller'>
        <div v-bind:key="item.src" class='home__client-div' v-for="item in clients">
          <img :src="item.src">
        </div>
      </div>
      <p class='home__view-more'>
        <router-link to='/clientele'>View More</router-link>
      </p>
    </div>
  </section>
  <hr class='common__section-divider' />
  <section>
    <SectionHeader title="Testimonial"></SectionHeader>
    <div class='home__testimonials-container'>
      <div v-bind:key="item.comment" class='home__testimonial' v-for="item in testimonials">
        <p>“{{item.comment}}”</p>
        <div>
          <label>{{item.label1}}</label>
          <label>{{item.label2}}</label>
          <label>{{item.label3}}</label>
        </div>
      </div>
    </div>
    <div class='home__testimonials-container--mobile'>
      <carousel :per-page="1" :loop="true" :paginationEnabled="false" :navigationEnabled="true">
        <slide v-bind:key="item.comment" v-for="item in testimonials">
          <div class='home__testimonial'>
            <p>“{{item.comment}}”</p>
            <div>
              <label>{{item.label1}}</label>
              <label>{{item.label2}}</label>
              <label>{{item.label3}}</label>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
  </section>
  <hr class='common__section-divider' />
  <section>
    <SectionHeader title="Enquiry form"></SectionHeader>
    <EnquiryForm class='home__enquiry-form'></EnquiryForm>
  </section>
  </div>
</template>
<style lang="scss">
@import '../sass/_variables.scss';

.home__banner {
  margin: 0;

  .VueCarousel-navigation-next {
    background: (url('../assets/images/home/icon-next-gray.png') center center no-repeat);
    background-size: 50px;
    color: transparent !important;
    right: 30px !important;
  }

  .VueCarousel-navigation-prev {
    background: (url('../assets/images/home/icon-prev-gray.png') center center no-repeat);
    background-size: 50px;
    color: transparent !important;
    left: 30px !important;
  }

  @media (max-width: $md-screen) {
    margin: -10px 0 0;
  }
}
.home__slide-image {
  width: 100%;
}
.home__company-insight {
  @media (max-width: $md-screen) {
    p {
      margin: 5px 0;
    }
  }
}
.home__view-more {
  text-align: center;
  margin: 10px 0 20px;
  a {
    color: $fc-chrome;
  }

  @media (max-width: $md-screen) {
    margin: 5px 0 10px;
  }
}
.home__clientele-body {
  box-shadow: none;
  padding: 0;
}
.home__clients-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: $md-screen) {
    flex-wrap: nowrap;
    overflow: auto;
  }
}
.home__client-div {
  padding: 9px 20px 5px;
  box-shadow: 0px 3px 4px -2px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  margin: 10px;
  min-width: 120px;
  width: calc(17% - 60px);
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: 50px;
  }
}
.home__gallery-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px 20px 0;

  @media (max-width: $md-screen) {
    min-width: 280px;
    height: 100%;
    flex-wrap: nowrap;
    padding: 0;
    overflow: auto;
  }
}
.home__gallery-div {
  border: 1px solid $bdc-light-grey;
  border-radius: 10px;
  margin: 20px 0;
  min-width: 220px;
  width: calc(33% - 50px);
  max-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
  }

  @media (max-width: $md-screen) {
    min-width: 280px;
    height: 100%;
    margin: 10px;
  }
}
.home__testimonials-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px;

  @media (max-width: $md-screen) {
    display: none;
  }
}
.home__testimonials-container--mobile {
  display: none;

  .VueCarousel {
    width: calc(100% - 10vw);
    margin: 5vw;
  }

  .VueCarousel-slide {
    display: flex;
    justify-content: center;
  }

  .VueCarousel-navigation-next {
    background: (url('../assets/images/home/icon-next-chrome.png') center center no-repeat);
    background-size: 50px;
    color: transparent !important;
  }

  .VueCarousel-navigation-prev {
    background: (url('../assets/images/home/icon-prev-chrome.png') center center no-repeat);
    background-size: 50px;
    color: transparent !important;
  }

  @media (max-width: $md-screen) {
    display: flex;
  }
}
.home__testimonial {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 30%;
  max-width: 30%;
  margin: 10px 0;  
  padding: 10px;
  box-shadow: 0px 2px 2px 1px rgba(0,0,0,0.5);
  p {
    margin: 5px 0 10px;
  }
  label {
    display: block;
    font-style: italic;
    font-weight: 600;
  }

  @media (max-width: $md-screen) {
    min-width: 280px;
    width: calc(100vw - 140px);
  }
}
.home__enquiry-form {
  max-width: 720px;
  margin: 10px auto;

  @media (max-width: $md-screen) {
    margin: 10px;
  }
}
</style>
<script>
import { Carousel, Slide } from 'vue-carousel';
import SectionHeader from '@/components/sectionHeader.vue'
import EnquiryForm from '@/components/enquiryForm.vue'

export default {
  name: 'home',
  components: {
    Carousel,
    Slide,
    SectionHeader,
    EnquiryForm
  },
  data: () => ({
    clients: [
      { src: require('../assets/images/clients/client1.png') },
      { src: require('../assets/images/clients/client2.png') },
      { src: require('../assets/images/clients/client3.png') },
      { src: require('../assets/images/clients/client4.png') },
      { src: require('../assets/images/clients/client6.png') }
    ],
    gallery: [
      { src: require('../assets/images/gallery/gallery1.png') },
      { src: require('../assets/images/gallery/gallery2.png') },
      { src: require('../assets/images/gallery/gallery3.png') },
      { src: require('../assets/images/gallery/gallery4.png') },
      { src: require('../assets/images/gallery/gallery5.png') },
      { src: require('../assets/images/gallery/gallery6.png') }
    ],
    testimonials: [{
      comment: 'Professional team with experienced technical personnel',
      label1: 'Balaji Singh',
      label2: 'Senior Engineer, Electrical Maintenance Dept',
      label3: 'S.K.F Bearings, Bengaluru'
    }, {
      comment:'Most competitive industry pricing, with good technical know how',
      label1: 'Chandrashekar',
      label2: 'Senior Electrical Engineer',
      label3: 'Himatsingka Linens, Hassan'
    }, {
      comment: 'Good response and immediate action for problem resolving',
      label1: 'Suresh Patil',
      label2: 'Technical Head',
      label3: 'Ajmera Housing, Electronic City, Bengaluru'
    }, {
      comment: 'One stop solution for all your HT Maintenance',
      label1: 'Anil',
      label2: 'Electrical Maintenance',
      label3: 'Brigade Millenium Apartments, Bengaluru'
    }, {
      comment: 'Good support with vast experienced technical personnel serving our establishment for many years',
      label1: 'Srinivas',
      label2: 'Manager, Electrical Maintenance',
      label3: 'SHAHI EXPORTS, Bengaluru'
    }, {
      comment: 'Long Association, Flagship Company',
      label1: 'Mr. Raja',
      label2: 'Estate Manager, Purva Riviera Apartments',
      label3: 'Marathahalli, Bangalore'
    }]
  })
}
</script>
